// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/clear_generation_grading.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionGeneration } from "./vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "./vision_generation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/clear_generation_grading.proto.
 */
export const file_vision_generations_v1_clear_generation_grading: GenFile = /*@__PURE__*/
  fileDesc("CjR2aXNpb24vZ2VuZXJhdGlvbnMvdjEvY2xlYXJfZ2VuZXJhdGlvbl9ncmFkaW5nLnByb3RvEhxwcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxIpQBCh1DbGVhckdlbmVyYXRpb25HcmFkaW5nUmVxdWVzdBJSCgZwYXJhbXMYASABKAsyQi5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLkNsZWFyR2VuZXJhdGlvbkdyYWRpbmdSZXF1ZXN0LlBhcmFtcxofCgZQYXJhbXMSFQoNZ2VuZXJhdGlvbl9pZBgBIAEoCSLDAQoeQ2xlYXJHZW5lcmF0aW9uR3JhZGluZ1Jlc3BvbnNlElMKBnJlc3VsdBgBIAEoCzJDLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuQ2xlYXJHZW5lcmF0aW9uR3JhZGluZ1Jlc3BvbnNlLlJlc3VsdBpMCgZSZXN1bHQSQgoKZ2VuZXJhdGlvbhgBIAEoCzIuLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuVmlzaW9uR2VuZXJhdGlvbmIGcHJvdG8z", [file_vision_generations_v1_vision_generation]);

/**
 * @generated from message protos.vision.generations.v1.ClearGenerationGradingRequest
 */
export type ClearGenerationGradingRequest = Message<"protos.vision.generations.v1.ClearGenerationGradingRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ClearGenerationGradingRequest.Params params = 1;
   */
  params?: ClearGenerationGradingRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ClearGenerationGradingRequest.
 * Use `create(ClearGenerationGradingRequestSchema)` to create a new message.
 */
export const ClearGenerationGradingRequestSchema: GenMessage<ClearGenerationGradingRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_generation_grading, 0);

/**
 * @generated from message protos.vision.generations.v1.ClearGenerationGradingRequest.Params
 */
export type ClearGenerationGradingRequest_Params = Message<"protos.vision.generations.v1.ClearGenerationGradingRequest.Params"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;
};

/**
 * Describes the message protos.vision.generations.v1.ClearGenerationGradingRequest.Params.
 * Use `create(ClearGenerationGradingRequest_ParamsSchema)` to create a new message.
 */
export const ClearGenerationGradingRequest_ParamsSchema: GenMessage<ClearGenerationGradingRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_generation_grading, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.ClearGenerationGradingResponse
 */
export type ClearGenerationGradingResponse = Message<"protos.vision.generations.v1.ClearGenerationGradingResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ClearGenerationGradingResponse.Result result = 1;
   */
  result?: ClearGenerationGradingResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ClearGenerationGradingResponse.
 * Use `create(ClearGenerationGradingResponseSchema)` to create a new message.
 */
export const ClearGenerationGradingResponseSchema: GenMessage<ClearGenerationGradingResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_generation_grading, 1);

/**
 * @generated from message protos.vision.generations.v1.ClearGenerationGradingResponse.Result
 */
export type ClearGenerationGradingResponse_Result = Message<"protos.vision.generations.v1.ClearGenerationGradingResponse.Result"> & {
  /**
   * @generated from field: protos.vision.generations.v1.VisionGeneration generation = 1;
   */
  generation?: VisionGeneration | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ClearGenerationGradingResponse.Result.
 * Use `create(ClearGenerationGradingResponse_ResultSchema)` to create a new message.
 */
export const ClearGenerationGradingResponse_ResultSchema: GenMessage<ClearGenerationGradingResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_generation_grading, 1, 0);

